import MultiTabComponent, { ITab } from "../../../components/multi-tab-component/multi-tab-component";
import AggregatorAlertCases from "./aggregator_alertcases";
import AllAlertCases from "./all-alertcases";
import FinishedAlertCases from "./finished-alertcases";
import OpenActiveAlertCases from "./openactive-alertcases";
import PersonalAlertCases from "./personal-alertcases";

interface IAlertCasesProps {
  onActionClick?: (action_key: string, rowId: string) => void;
  onBeforeRowClick?: (rowId: string) => Promise<boolean>;
}

const AlertCasesTab = ({onActionClick, onBeforeRowClick}: IAlertCasesProps) => {
  const tabs: ITab[] = [
    {
      name: "Open/Active",
      key: "open_active_alertcases",
      content: <OpenActiveAlertCases onActionClick={onActionClick} onBeforeRowClick={onBeforeRowClick}/>
    },
    {
      name: "Personal",
      key: "personal_alertcases",
      content: <PersonalAlertCases onActionClick={onActionClick} onBeforeRowClick={onBeforeRowClick}/>
    },
    {
      name: "Aggregator",
      key: "aggregator_alertcases",
      content: <AggregatorAlertCases/>
    },
    {
      name: "Finished",
      key: "finished_alertcases",
      content: <FinishedAlertCases onActionClick={onActionClick} onBeforeRowClick={onBeforeRowClick}/>
    },
    {
      name: "All",
      key: "all_alertcases",
      content: <AllAlertCases onActionClick={onActionClick} onBeforeRowClick={onBeforeRowClick}/>
    }
  ];

  return <div className="allCasesTab">
    <MultiTabComponent tabs={tabs} displayNextButton={false} enableHashRouting={true} />
  </div>;
};

export default AlertCasesTab;